import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const PAGE = {
  width: 216,
  height: 279,
};

const sanitizeName = (name) => (name == null ? '' : String(name).trim());

export const normalizePriceListServices = (rows = []) => {
  return rows
    .map((row) => ({
      name: sanitizeName(row?.name),
      price: row?.price,
    }))
    .filter((service) => service.name !== '');
};

const makeFileSafeName = (value) => {
  const cleaned = sanitizeName(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return cleaned || 'company';
};

const chunkServices = (services, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < services.length; i += chunkSize) {
    chunks.push(services.slice(i, i + chunkSize));
  }
  return chunks;
};

export const generatePriceListPdf = async ({
  companyName,
  services,
  flyerElement,
  onBeforePageCapture,
  servicesPerPage = 11,
}) => {
  if (!Array.isArray(services) || services.length === 0 || !flyerElement) return false;

  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'letter',
  });
  const pages = chunkServices(services, servicesPerPage);

  for (let pageIndex = 0; pageIndex < pages.length; pageIndex += 1) {
    if (typeof onBeforePageCapture === 'function') {
      await onBeforePageCapture(pages[pageIndex], pageIndex, pages.length);
    }

    const canvas = await html2canvas(flyerElement, {
      useCORS: true,
      backgroundColor: '#e6eaed',
      scale: 2,
    });
    const image = canvas.toDataURL('image/jpeg', 1.0);
    if (pageIndex > 0) {
      doc.addPage('letter', 'portrait');
    }
    doc.addImage(image, 'JPEG', 0, 0, PAGE.width, PAGE.height);
  }

  const fileName = `price-list-${makeFileSafeName(companyName)}.pdf`;
  doc.save(fileName);
  return true;
};
